import {MAIN_URL} from "data/constants";

const addTrailingSlash = (link?: string) => {
	if (link) {
		const url = new URL(link);
		url.pathname += url.pathname.endsWith("/") ? "" : "/";
		return url.toString();
	}
	return "/";
};

export const buildRedirectURL = (path: "login" | "logout" | "profile" | "registration") => {
	return `${MAIN_URL}${path}?redirectUri=${addTrailingSlash(
		window.location.href
	)}?callback=${path}`;
};

export const goToURL = (url: string) => {
	window.location.assign(url);
};
